module.exports = __webpack_public_path__ + "img/placeholder-square.1e4c57d4.svg";